import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize, borderRadius } from '@atlassian/jira-common-styles/src';

export const loadingCellStyles = {
	backgroundColor: token('color.skeleton', colors.N20),
	paddingleft: '1px',
	borderRadius: `${borderRadius}px`,
	width: `calc(100% - ${gridSize * 2}px)`,
	height: `calc(100% - ${gridSize * 2}px)`,
	marginLeft: token('space.100', '8px'),
} as const;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LoadingCell = styled.div<{ width: number; height: number }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	...loadingCellStyles,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	width: ({ width }) => (width ? `${width - gridSize * 2}px` : `calc(100% - ${gridSize * 2}px)`),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: ({ height }) =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		height ? `${height - gridSize * 2}px` : `calc(100% - ${gridSize * 2}px)`,
});
